import React from 'react';
import './PopupCard.css';

const PopupCard = ({ open, onClose, title, text, image, inline }) => {
    if (!open) return null;

    // Format text with proper line breaks
    const formatText = (str) => {
        if (!str) return '';
        return str.split('\n').map((line, idx) => (
            <React.Fragment key={idx}>
                {line}
                {idx < str.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    const fallbackImage = '/images/about1.jpg';

    const card = (
        <div className="popup-card">
            <button className="popup-close" onClick={onClose}>✕</button>
            <img
                src={image || fallbackImage}
                alt={title}
                className="popup-image"
                onError={(e) => {
                    if (e.target.src !== fallbackImage) {
                        e.target.src = fallbackImage;
                    }
                }}
            />
            <h2>{title}</h2>
            <p className="popup-content">{formatText(text)}</p>
        </div>
    );

    if (inline) {
        // No overlay, just the card
        return card;
    }

    // Default: overlay mode
    return (
        <div className="popup-overlay" onClick={onClose}>
            <div className="popup-card" onClick={e => e.stopPropagation()}>
                <button className="popup-close" onClick={onClose}>✕</button>
                <img src={image} alt={title} className="popup-image" />
                <h2>{title}</h2>
                <p className="popup-content">{formatText(text)}</p>
            </div>
        </div>
    );
};

export default PopupCard;